const items = [
  { label: 'Pendiente / patología', symbolClass: 'bg-red-500 border-red-600', symbol: '' },
  { label: 'Realizado / existente', symbolClass: 'bg-blue-600 border-blue-700', symbol: '' },
  { label: 'Diente ausente o extraído', symbolClass: 'bg-white border-slate-700 text-red-700', symbol: '×' },
  { label: 'Corona', symbolClass: 'rounded-full bg-slate-300 border-2 border-slate-500', symbol: '' },
  { label: 'Endodoncia', symbolClass: 'bg-white border-violet-700 text-violet-700', symbol: '│' },
  { label: 'Puente', symbolClass: 'bg-white border-amber-700 text-amber-700', symbol: '—' },
];

export function OdontogramLegend() {
  return (
    <aside className="rounded-xl border border-slate-300 bg-white px-4 py-3" aria-label="Leyenda clínica">
      <h2 className="mb-2 text-xs font-bold uppercase tracking-wide text-slate-600">Leyenda</h2>
      <div className="grid grid-cols-2 gap-x-5 gap-y-2 sm:grid-cols-3 md:flex md:flex-wrap">
        {items.map((item) => (
          <span key={item.label} className="flex items-center gap-2 text-xs text-slate-600">
            <span
              className={`flex h-4 w-4 items-center justify-center border text-sm font-black leading-none ${item.symbolClass}`}
              aria-hidden="true"
            >
              {item.symbol}
            </span>
            {item.label}
          </span>
        ))}
      </div>
    </aside>
  );
}
